// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1M8rJ","box":"WorkspacesBox_box__29g3V","node":"WorkspacesBox_node__2VwDx"};